module.exports = __webpack_public_path__ + "static/media/logo_new.aac60654.png";